import { Component } from '@angular/core';
import { StorageService } from './services/StorageService';
import { HttpService } from './services/httpService';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'app';


  os; ip; route; browser; browserVersion;



  constructor(private localStorage: StorageService, private httpService: HttpService, public router: Router, private activeRoute: ActivatedRoute,
  ) {

    this.os = this.getMobileOperatingSystem();

    this.browser = this.detectBrowserName();

    this.browserVersion = this.detectBrowserVersion();


    this.router.events.subscribe((res) => {
      //console.log(this.router.url, "Current URL");
      this.route = this.router.url;


    })





    this.httpService.getExternalUrl('https://api.ipify.org?format=json')
      .subscribe(data => {

        this.localStorage.set('IpAddress', data.ip.toString());
        this.ip = data.ip.toString();


        this.logVisit();



        error => {


        }

      })



  }



  detectBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }











  detectBrowserVersion() {
    var userAgent = navigator.userAgent, tem,
      matchTest = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (/trident/i.test(matchTest[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
      return 'IE ' + (tem[1] || '');
    }
    if (matchTest[1] === 'Chrome') {
      tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    matchTest = matchTest[2] ? [matchTest[1], matchTest[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = userAgent.match(/version\/(\d+)/i)) != null) matchTest.splice(1, 1, tem[1]);
    return matchTest.join(' ');
  }






  logVisit() {



    const request = {
      route: this.route,
      ipAddress: this.ip,
      deviceType: this.os,
      browser: this.browser + " | " + this.browserVersion
    }

    this.httpService.post<any>('Store/website-view', request, false).subscribe(
      resp => {

        this.localStorage.set('VisitIdentifier', JSON.parse(resp.message).message);


      },
      error => {

      });


  }




























  scrollTop() {

    window.scroll(0, 0);

  }






  getMobileOperatingSystem() {
    var userAgent = navigator.userAgent;

    if (userAgent.toUpperCase().indexOf('ANDROID') > 0) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710

    if (userAgent.toUpperCase().indexOf('IPAD') > 0 || userAgent.toUpperCase().indexOf('IPHONE') > 0 || userAgent.toUpperCase().indexOf('IPOD') > 0) {
      return "iOS";
    }

    return "unknown";

  }







}
